import React, { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { FormButtons, FormRow, FileUpload, Loading } from '../controls';

function buildDefaultValues(faq) {
  return {
    faqName: faq.faqName || '',
    faqDescription: faq.faqDescription || '',
    priority: faq.priority || 0,
  };
}

export function FAQForm({
  faq,
  onFileUpload,
  loading,
  handleSave,
  handleRemove,
  onFileDelete,
}) {
  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: buildDefaultValues(faq),
    mode: 'onSubmit',
  });

  useEffect(() => {
    reset(buildDefaultValues(faq));
  }, [faq, reset]);

  const fileList = [];

  if (faq.photoURL) {
    fileList.push({
      uid: '-1',
      name: faq.faqPhoto,
      url: faq.photoURL,
      status: 'done',
    });
  }

  return (
    <form onSubmit={handleSubmit(handleSave)}>
      <div className="flex">
        <div className="flex w-3/4 flex-wrap items-center p-4">
          <FormRow label="FAQ Name" error={errors.faqName?.message}>
            <input
              type="text"
              placeholder="Name"
              {...register('faqName', { required: 'FAQ name is required' })}
            />
          </FormRow>
          <FormRow label="Full Screen">
            <Controller
              name="priority"
              control={control}
              render={({ field }) => (
                <input
                  type="checkbox"
                  className="h-5 w-10 cursor-pointer rounded-full accent-[var(--primary)]"
                  checked={Number(field.value) === 1}
                  onChange={(e) => field.onChange(e.target.checked ? 1 : 0)}
                  aria-label="Full screen FAQ"
                />
              )}
            />
          </FormRow>
        </div>
        <div className="w-1/4 p-4">
          <FormRow>
            <div className="w-full">
              <FileUpload
                fileList={fileList}
                onFileUpload={onFileUpload}
                onFileDelete={onFileDelete}
              />
            </div>
          </FormRow>
        </div>
      </div>
      <FormRow label="Description" error={errors.faqDescription?.message}>
        <textarea
          placeholder="FAQ Description..."
          {...register('faqDescription', {
            required: 'Description is required',
          })}
        />
      </FormRow>
      {loading && <Loading />}
      <FormButtons showDelete={faq.faqId} title="FAQ" onDelete={handleRemove} />
    </form>
  );
}
